import type { FaireProductEntity } from "../../entity_types/product";

export const p_h9wdfgy3x6: FaireProductEntity = {
  token: "p_h9wdfgy3x6",
  type: "product",
  name: "Immuniboost - Chaga, Phellinus, Reishi & Turkey Tail",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/1139ce14fc92b15a5aa170481c15171457fe5e58687a669d749c6c1eede8167c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d1f90d5c8750e4656992e58e0677a0540456b77f806a1ec102a9c153840ee2e.png",
    "https://cdn.faire.com/fastly/3ca1bebbd7a4f9f2370b75af89b2ba2960ac6b8553f2e170b484e9cd2f349441.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nTurkey Tail, Reishi, and Phellinus activate and upregulate both innate and adaptive immunity and regulate blood sugar. The powerful Chaga mushroom shields our bodies against viral, bacterial, fungal & parasitic infections. Combined, their high triterpenoid content also offers anti-oxidant and anti-inflammatory benefits.*\n\nThe mushrooms in Immuniboost are organically cultivated in their favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability).\n\nBETA GLUCANS | 515mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:44.348Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
